import React from 'react'
import { withStyles } from '@material-ui/styles'
import { Form as RsForm, Row, Col, Label } from 'reactstrap'
import { Grid, Column, iconCell, enumCell, dateCell, createEnumFilterCell } from 'components/grid'
import { Select } from 'components/select'
import { localized } from 'decorators'
import { urls } from 'urls'
import { Page } from 'components/page'
import { Button } from 'components/buttons'
import { OrderProcessingDetailPage } from './detail'
import { DatePickerRange } from 'components/datePickerRange'
import { api as suppliersApi } from 'store/modules/lookups/suppliers/api'
import { api as ordersApi } from 'store/modules/orders'
import { orderStatus } from 'enums/orderStatus'
import { history } from 'store/modules'
import { formatDate, fromUtcString } from 'utils/dateUtilities'
import { withPersistence } from 'decorators'
import { styles } from './index.css'

export const metadata = {
  icon: 'newspaper-o',
  urls: urls.orderProcessing,
  nameGetter: x => `${x.supplierName} (${formatDate(x.dateOfOrder)})`
}

const onRowClick = (e) => history.push(`${urls.orderProcessing.base}/${e.dataItem.id}`)

const prepareStaticFilters = ({ supplier, useDateFilter, since, until }) => {
  const filters = [{ field: 'status', operator: 'neq', value: orderStatus.created }]
  if (supplier) {
    filters.push({ field: 'supplierId', operator: 'eq', value: supplier.id })
  }
  if (useDateFilter) {
    if (since) { filters.push({ field: 'dateOfOrder', operator: 'gte', value: since }) }
    if (until) { filters.push({ field: 'dateOfOrder', operator: 'lte', value: until }) }
  }
  return filters
}

class OrderProcessing extends React.Component {
  constructor(props, context) {
    super(props, context)

    const savedState = props.persistor.get({
      supplier: null,
      useDateFilter: false,
      since: null,
      until: null,
      staticFilter: null
    })
    this.state = {
      ...savedState,
      since: fromUtcString(savedState.since),
      until: fromUtcString(savedState.until),
      staticFilter: null
    }
  }
  onSearchClick = () => {
    const { supplier, useDateFilter, since, until } = this.state
    this.setState({ staticFilter: prepareStaticFilters({ supplier, useDateFilter, since, until }) })
    this.props.persistor.set({ supplier, useDateFilter, since, until })
  }
  render () {
    const { localize, classes } = this.props
    const { supplier, useDateFilter, since, until, staticFilter } = this.state
    return (
      <Page
        metadata={metadata}
        title={localize(`ordersProcessing.detailTitle`)}
        hideGoBack>
          <RsForm>
            <Row>
              <Col sm='6'>
                <Label>{localize('ordersProcessing.supplier')}</Label>
                <Select
                  dataSource={suppliersApi.get}
                  value={supplier}
                  onChange={supplier => this.setState({ supplier })}
                  nullable
                  />
              </Col>
            </Row>
            <Row>
              <Col sm='6'>
                <Label>{localize('ordersProcessing.dateOfOrder')}</Label>
                  <DatePickerRange
                    useDateFilter={useDateFilter}
                    onUseDateFilterChange={useDateFilter => this.setState({ useDateFilter })}
                    since={since}
                    onSinceChange={since => this.setState({ since })}
                    until={until}
                    onUntilChange={until => this.setState({ until })}
                  />
              </Col>
            </Row>
            <Row>
              <Col sm='6' className={classes.filterButton}>
                <Button icon='search' onClick={this.onSearchClick}>{localize('ordersProcessing.filter')}</Button>
              </Col>
            </Row>
            <Row><Col><hr /></Col></Row>
            {staticFilter !== null && <Row>
              <Col>
                <Grid
                    dataSource={ordersApi.get}
                    staticFilters={staticFilter}
                    onRowClick={onRowClick}>
                    <Column field='id' title={localize('common.id')} width='70px' filterable={false} />
                    <Column field='supplierName' title={localize('orders.supplier')} cell={iconCell({ icon: 'shopping-bag' })} width='250px' />
                    <Column field='dateOfOrder' title={localize('orders.dateOfOrder')} filter='date' cell={dateCell()} filterable={false} />
                    <Column field='totalUnits' title={localize('orders.totalUnits')} filter='numeric' filterable={false} />
                    <Column field='status' title={localize('orders.status')} cell={enumCell({ enum: orderStatus })} filterable={false} filterCell={createEnumFilterCell({ enum: orderStatus, width: 210 })} width='230px' />
                </Grid>
              </Col>
            </Row>}
          </RsForm>
      </Page>
    )
  }
}
const OrderProcessingPage = withStyles(styles)(withPersistence('page:orderProcessing', localized(OrderProcessing)))
export {
  OrderProcessingPage,
  OrderProcessingDetailPage
}